import { useQuery } from 'react-query';

import { getCheckout } from '../api';

export const checkoutQuery = params => ({
  queryKey: ['checkout', params.start_date, params.end_date, params.branch_id],
  queryFn: async () => {
    const res = await getCheckout(params);
    return res.data;
  },
  staleTime: Infinity,
  retry: false,
});

export const useCheckout = (params, options = {}) => {
  return useQuery({ ...checkoutQuery(params), ...options });
};
